import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { formatDate } from '@fullcalendar/common';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/etity-form-provider.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import moment from 'moment';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-invoice-form',
  components: {
    'bpc-std-form': StdForm,
  },
})
export default class InvoiceForm extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): Promise<BPCGenericApiResponse>;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };
  @Prop(String) readonly entity: string;
  @Prop([String, Number]) readonly entityId: string | number;
  @Prop([Object]) readonly value: AnyEntity;
  @Prop({ type: String, default: 'default' }) formConfigName: string;
  @Prop({ type: String }) permissionEntityName: string;
  @Prop({ type: Boolean, default: false }) disabled: string;
  @Prop({ type: String, default: null }) readonly savePath: string;

  public formModel: AnyEntity = {};
  public firstTimeLoadingContact: boolean = true;
  // created() {}
  mounted() {
    this.$root.$on('changeArticleType', val => {
      this.$refs.stdForm.formModel.articleBookingDetail = null;
    });
  }
  destroyed() {
    this.$root.$off('changeArticleType');
  }

  onFormSaved(e) {
    this.$emit('entity-saved', e);
  }
  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }
  deleteMediaFile(event) {
    this.$emit('delete-media-file', event);
  }
  async saveEntity(): Promise<BPCGenericApiResponse> {
    return await this.$refs.stdForm.saveEntity();
  }

  onModelLoaded($event) {
    this.$emit('model-loaded', $event);
  }

  get contactId(): number {
    return this.formModel?.contact?.id || null;
  }

  setInvoiceLayout() {
    const contactLayout = this.formModel.contact?.default_invoice_layout || null;
    const centerSettingLayout = this.$store.getters['centerSettings/defaultInvoiceLayout'] || null;
    const layout = contactLayout || centerSettingLayout || 'full_details';

    this.formModel.invoice_layout = layout;
  }

  @Watch('contactId')
  onContactIdChange(val, oldVal) {
    if (oldVal || !this.firstTimeLoadingContact) {
      this.firstTimeLoadingContact = false;
      this.setInvoiceLayout();
    }
  }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    this.$emit('input', this.formModel);
  }
}
